import { createActionCreator } from 'deox';
import { PlacementConfig } from '../models/placement-config.model';
import { PlacementMetadata } from '../models/placement-meta-data.model';

export const redirectToUrl = createActionCreator(
  'REDIRECT_TO_URL',
  resolve => (payload: {
    placementConfig: PlacementConfig,
    placementMetaData: PlacementMetadata,
    targetUrl: string,
    target: string,
  }) => resolve(payload),
);
